/**
 * Method of inserting third party tools.
 * @module global/thirdpart-global
 */
define('thirdparty-global',["jquery"], function($){
    //---------------------------------------[ Set jQuery AJAX to cache
    $.ajaxSetup({
        cache: true
    });

    $(document).ready(function(){
        //---------------------------------------[ Begin Nielsen Online SiteCensus V6.0
        var neilson_src = ["//secure-us.imrworldwide.com/cgi-bin/m?ci=us-903454h&cg=0&cc=1&si=", escape(window.location.href), "&rp=", escape(document.referrer), "&ts=compact&rnd=", (new Date()).getTime()].join('');
        $('<img src="' + neilson_src + '" alt="empty">').appendTo("body");
        //---------------------------------------[ End Nielsen Online SiteCensus V6.0

        //---------------------------------------[  Begin comScore config
        _comscore = (typeof _comscore === "undefined") ? [] : _comscore;
        _comscore.push({ c1: "2", c2: "16922960" });
        //---------------------------------------[  End comScore config

        //---------------------------------------[  Begin Quantcast config
        // Begin Quantcast Tag Trying moving it here b/c of reporting issues
        var _qevents = _qevents || [];

        (function() {
            var elem = document.createElement('script');
            elem.src = (document.location.protocol == "https:" ? "https://secure" : "http://edge") + ".quantserve.com/quant.js";
            elem.async = true;
            elem.type = "text/javascript";
            var scpt = document.getElementsByTagName('script')[0];
            scpt.parentNode.insertBefore(elem, scpt);
        })();

        _qevents.push({
            qacct:"p-vhFSUHh2EBRZ4"
        });
        // End Quantcast tag
        //---------------------------------------[  End Quantcast config


        /*
         * Load the third party stuff.
         */
        var third_party_libs = ["jquery", "twitter", "comscore"/*, "quantcast"*/];

        // datronics does not support https, skip it if we are secure
        if ('https:' != document.location.protocol) {
            third_party_libs.push('datronics');
        }
        require(third_party_libs, function () {
            //---------------------------------------[  Begin Quantcast init
            // moved to head _qevents.push({qacct:"p-vhFSUHh2EBRZ4"});
            //---------------------------------------[  End Quantcast init
        }, function(err){
            // An error occurred
            var failedId = err.requireModules && err.requireModules[0];

            switch( failedId ) {
                case "twitter":
                case "comscore":
                case "datronics":
                case "quantcast":
                    requirejs.undef(failedId);
                    break;
                default:
                    // That just leaves jQuery... don't think we want to undefine that.
                    // But, since we're in a $(document).ready function anyway, this can't happen, right?
            }
        });

        // liveramp iframe from _footer
        if (typeof vspot_rl_src !== 'undefined' && vspot_rl_src) {
            var f = document.createElement('iframe');
            f.src=vspot_rl_src; f.width=0; f.height=0;
            $('body').append(f);
        }
    });  // document.ready


});

